import { ComponentInstall } from "../../utils";
import Select from "./src";

export default ComponentInstall(Select);
